(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zc-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function hiddenCount(root) {
      var n = 0;
      root.querySelectorAll('.zcr-card').forEach(function (c) { if (getComputedStyle(c).display === 'none') n++; });
      return n;
    }

    function initToggle(root) {
      var btn = root.querySelector('[data-zcr-toggle]');
      if (!btn) return;
      var wrap = root.querySelector('[data-zcr-toggle-wrap]');
      var less = root.querySelector('[data-zcr-less]');
      var label = root.querySelector('[data-zcr-label]');
      var heading = root.querySelector('.zcr__title');
      var list = root.querySelector('[data-zcr-list]');

      function nextUrl() { return list ? list.getAttribute('data-next') : ''; }
      function render() {
        var expanded = root.classList.contains('is-expanded');
        var more = !!nextUrl();
        root.classList.toggle('is-complete', expanded && !more);
        label.textContent = expanded && !more ? 'Show less reviews' : 'Show more reviews';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (less) less.hidden = !(expanded && more);
        wrap.hidden = !expanded && !more && hiddenCount(root) === 0;
      }
      function collapse() {
        root.classList.remove('is-expanded');
        render();
        if (heading) heading.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
      function loadMore() {
        var url = nextUrl();
        if (!url) return;
        btn.setAttribute('aria-busy', 'true');
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        fetch(url + sep + 'section_id=' + encodeURIComponent(list.getAttribute('data-section')), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextList = doc.querySelector('[data-zcr-list]');
            if (!nextList) throw new Error('no list');
            nextList.querySelectorAll('.zcr-card').forEach(function (card) { list.appendChild(document.importNode(card, true)); });
            list.setAttribute('data-next', nextList.getAttribute('data-next') || '');
          })
          .catch(function () { list.setAttribute('data-next', ''); })
          .then(function () { btn.removeAttribute('aria-busy'); render(); });
      }

      btn.addEventListener('click', function () {
        if (!root.classList.contains('is-expanded')) {
          root.classList.add('is-expanded');
          if (hiddenCount(root) === 0 && nextUrl()) loadMore();
          render();
        } else if (nextUrl()) {
          loadMore();
        } else {
          collapse();
        }
      });
      if (less) less.addEventListener('click', collapse);
      render();
      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(render, 120); });
    }

    function initLightbox(root) {
      var box = root.querySelector('[data-zcr-lightbox]');
      if (!box || typeof box.showModal !== 'function') return;
      var img = box.querySelector('[data-zcr-lightbox-img]');
      var prev = box.querySelector('[data-zcr-prev]');
      var next = box.querySelector('[data-zcr-next]');
      var set = [], index = 0, opener = null;

      function show(i) {
        index = (i + set.length) % set.length;
        var el = set[index];
        img.src = el.dataset.src;
        if (el.dataset.w && el.dataset.h) { img.width = el.dataset.w; img.height = el.dataset.h; }
        img.alt = 'Customer photo ' + (index + 1) + ' of ' + set.length;
        prev.hidden = next.hidden = set.length < 2;
      }
      /* Delegated, so photos of reviews loaded later with "Show more reviews" open too. */
      root.addEventListener('click', function (e) {
        var el = e.target.closest('[data-zcr-photo]');
        if (!el || !root.contains(el)) return;
        set = Array.prototype.slice.call(el.closest('[data-zcr-gallery]').querySelectorAll('[data-zcr-photo]'));
        opener = el;
        show(set.indexOf(el));
        box.showModal();
      });
      prev.addEventListener('click', function () { show(index - 1); });
      next.addEventListener('click', function () { show(index + 1); });
      box.querySelector('[data-zcr-close]').addEventListener('click', function () { box.close(); });
      box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
      box.addEventListener('keydown', function (e) {
        if (set.length < 2) return;
        if (e.key === 'ArrowLeft') show(index - 1);
        if (e.key === 'ArrowRight') show(index + 1);
      });
      box.addEventListener('close', function () { img.removeAttribute('src'); if (opener) opener.focus(); });
    }

    function init(root) {
      if (root.dataset.zcrBound) return;
      root.dataset.zcrBound = '1';
      initToggle(root);
      initLightbox(root);
    }
    function run() { document.querySelectorAll('[data-zcr]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
